import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import AlertContactForm from './AlertContactForm';
import '../assets/css/WebDevelopment.css';
import manati from '../assets/img/Manatigirl.png';
import Acceduboy from '../assets/img/Acceduboy.png';
import studenthero from '../assets/img/student_hero.png';




const Diploma = () => {
  const [toggle] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Techblume | Courses - Diploma</title>
      </Helmet>

      {toggle && <AlertContactForm />}

      {/* Course Section */}

      {/*Funding Section */}
      
          <div className='Projects-page'>
            
      
             <div className='project-section2'>
                <h1>Student Funding</h1>
                <p>Apply for Student Funding — Fast, Simple & Free</p>
                <section>
  
                <img src={studenthero} alt="studenthero"   style={{ width: '400px', height: '250px', marginLeft: '-19px' }}  />
                
                  
                  <main>
                      <h2 className="blue-heading">Student Hero – Education Funding for South African Students</h2>
                      <h1>Techblume has partnered with <b>STUDENT HERO </b> to offer South African students access to a free, all-in-one education funding platform. Students can easily compare and apply for study loans from trusted South African banks and financial institutions through a secure and simple process—making education funding easier than ever.</h1>
                     
                 {/* Apply Now Button */}
                    <a href="https://landbot.pro/v3/H-2740333-I5PJCXGRK7YZOO13/index.html" className="apply-button" target="_blank" rel="noopener noreferrer">Apply Now</a>
                  </main>
                </section>
                <section>
  
                <img src={manati} alt="manati"   style={{ width: '400px', height: '250px', marginLeft: '-19px' }}  />
                
                  
                  <main>
                      <h2 className="blue-heading">Manati – Making Education Funding Simple for South African Students</h2>
                      <h1>Techblume has partnered with <b>Manati </b> to provide South African students with access to a free, comprehensive education funding platform. The platform enables students to compare and apply for study loans from reliable South African banks and financial institutions through a secure and easy-to-use process, simplifying education financing.</h1>
                     {/* Apply Now Button */}
                    <a href="https://chats.landbot.io/v3/H-710586-TZA6006OCE2GJZWZ/index.html" className="apply-button" target="_blank" rel="noopener noreferrer">Apply Now</a>
                  </main>
                </section>
                <section>
  
                <img src={Acceduboy} alt="Acceduboy"   style={{ width: '400px', height: '250px', marginLeft: '-19px' }}  />
                
                  
                  <main>
                      <h2 className="blue-heading">Accede Education – Education Funding for Mexican Students</h2>
                      <h1>Techblume has partnered with <b>Accede Education </b> to support Mexican students with access to a free, all-in-one education funding platform. Students can compare and apply for study loans from leading Mexican banks and financial institutions through a secure and streamlined process, making education financing simple and accessible.</h1>
                     {/* Apply Now Button */}
                    <a href="https://app.accedeeducacion.com/creditos/techblume" className="apply-button" target="_blank" rel="noopener noreferrer" >Apply Now</a>
                  </main>
                </section>
                     
             </div>
             
          </div>

      {/* FAQ Section */}
   
    </>
  );
};

export default Diploma;
